import * as THREE from 'three';

// ابزارهای کوچکِ کمکی که هنوز لازم‌اند. بافت‌های کدنویسی‌شده‌ی جنس‌ها (کاشی/آجر/سنگ/پارکت/موکت/بتن/
// کاغذ دیواریِ canvas) از این فایل حذف شده‌اند — همه‌ی جنس‌ها حالا یا «رنگِ ساده»اند یا عکسِ واقعیِ PBR
// (pbrTextures.jsx). آن‌چه این‌جا مانده فقط برای سقف است: shadeColor (رنگِ قرنیز) و createVignetteTexture
// (سایه‌ی نرمِ گوشه‌ها / درخششِ نورِ مخفی).

function createCanvas(width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

// رنگ را کمی روشن/تیره می‌کند (percent منفی = تیره‌تر) — برای سایه‌های سبکِ داخلِ خودِ بافت (مثلِ
// درزهای پارکت)، بدونِ نیاز به کتابخانه‌ی رنگِ جداگانه
export function shadeColor(hex, percent) {
  const clean = hex.replace('#', '');
  const num = parseInt(clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean, 16);
  const amt = Math.round((percent / 100) * 255);
  let r = (num >> 16) + amt;
  let g = ((num >> 8) & 0xff) + amt;
  let b = (num & 0xff) + amt;
  r = clamp(r, 0, 255);
  g = clamp(g, 0, 255);
  b = clamp(b, 0, 255);
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

// وینیتِ نرمِ دورِ لبه: مرکز کاملاً شفاف، نزدیکِ لبه‌ها به‌تدریج به رنگِ tint می‌رسد — برای سقف،
// روی یک صفحه‌ی مجزا (کمی پایین‌ترِ خودِ سقف) کشیده می‌شود تا هم گوشه‌های اتاق کمی تیره‌تر/طبیعی‌تر
// دیده شوند (افتِ نورِ محیطی در گوشه‌ها، همان چیزی که هر سقفِ واقعی دارد)، هم برای «نورِ مخفی» بشود
// همین تابع را با رنگِ گرمِ خودِ نوار و blending جمعی صدا زد تا حسِ نورِ پخش‌شده روی سقف را بدهد.
// strength آلفای نهایی در لبه است (۰ تا ۱)؛ چون این یک اورلیِ مجزاست نه بخشی از بافتِ خودِ جنس،
// برای هر نوعِ سقفی (ساده/کاشی/چوبی/...) یکسان کار می‌کند، بدونِ دست‌زدن به بافتِ خودِ جنس
export function createVignetteTexture(tint = '#000000', strength = 0.35) {
  const size = 512;
  const canvas = createCanvas(size, size);
  const ctx = canvas.getContext('2d');
  const cx = size / 2;
  const cy = size / 2;
  const gradient = ctx.createRadialGradient(cx, cy, size * 0.2, cx, cy, size * 0.74);
  gradient.addColorStop(0, `${tint}00`);
  gradient.addColorStop(1, tint);
  ctx.fillStyle = gradient;
  ctx.globalAlpha = clamp(strength, 0, 1);
  ctx.fillRect(0, 0, size, size);
  ctx.globalAlpha = 1;
  const texture = new THREE.CanvasTexture(canvas);
  texture.needsUpdate = true;
  return texture;
}